import { render, staticRenderFns } from "./offline_order.vue?vue&type=template&id=32346776&"
import script from "./offline_order.vue?vue&type=script&lang=js&"
export * from "./offline_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports